import React, { useEffect, useCallback } from "react";
import { useSearchParams } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { apiCall } from "../../utils/server_utils";
import { API_SUCCESS_RESPONSE_CODE,PRODUCT_NAME} from "../../utils/config_mapping";
import login_bg from "../../assets/images/login_bg.svg"; // Adjust the path
import { AuthData } from "../../auth/AuthWrapper";
import { useNavigate } from "react-router-dom";

export const LoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const { login } = AuthData();
  const navigate = useNavigate();

  const success = searchParams.get('success');
  const data = searchParams.get('data');
  const error = searchParams.get('error');
  const code = searchParams.get('code');
  const accessToken = searchParams.get('access_token');
  const refreshToken = searchParams.get('refresh_token');
  
  const jsonObject = {
    success: success,
    data: data,
    error: error,
    code: code,
    accessToken: accessToken,
    refreshToken: refreshToken
  };
  
  if (accessToken !== "" && accessToken !== "") {
    localStorage.setItem("jsondata", JSON.stringify(jsonObject));
  }

  // Memoize the login and navigate functions
  const handleLogin = useCallback((name) => {
    login(name, 'password');
  }, [login]);

  const handleNavigate = useCallback(() => {
    navigate("/document-list");
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiCall("GET", `${API_SERVER_URL}me/`);
        if (result !== undefined && result.code === API_SUCCESS_RESPONSE_CODE) {

          //await handleLogin("Rajajn");
          //localStorage.setItem("organization", "PRE");
          await handleLogin(result.data.data.fullName);
          localStorage.setItem("organization", result.data.data.tenantName);

          handleNavigate();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [handleLogin, handleNavigate]);

  return (
    <>
      <div className="auth-page-wrapper pt-5">
        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay"></div>
          <div className="shape">
            <img src={login_bg} alt="Login Background" />
          </div>
          <div className="auth-page-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="text-center mt-sm-5 mb-4 text-white-50">
                                           <img className="logo-img" src="data:image/webp;base64,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" alt=""></img>

                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6 col-xl-5">
                  <div className="card mt-4 card-bg-fill">
                    <div className="card-body p-4">
                      <div className="text-center mt-2">
                        <h3 className="text-primary mb-3" dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} />
                        <h5 className="text-primary">Welcome Back!</h5>
                      </div>
                      <div className="p-2 mt-4">
                        {/* Additional form fields or content */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
